import { Edit, Menu, X } from "lucide-react";
import { useState } from "react";

import { NavLink } from "react-router-dom";

import { cn } from "@/lib/utils";

import LastUpdate from "./last-update";
import { ShareModal } from "./share-modal";

const ProfileNavbar = () => {
  const profileEditNavItems = [
    {
      label: "درباره من",
      href: ""
    },
    {
      label: "اطلاعات پژوهشی",
      href: "research"
    },
    {
      label: "اطلاعات تحصیلی و آموزشی",
      href: "education"
    },
    {
      label: "وبسایت‌ و شبکه‌های اجتماعی",
      href: "social-links"
    },
    {
      label: "اخبار و اطلاعیه ها",
      href: "news"
    }
  ];
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <div className="hidden lg:flex mb-2 h-10 w-full items-center bg-[#E4EBF3] pe-4">
        <ul className="flex h-full bg-white">
          {profileEditNavItems.map((item, index) => (
            <li key={index}>
              <NavLink
                to={item.href}
                className={({ isActive }) => {
                  if (isActive) setActiveIndex(index);

                  return cn(
                    "navlink flex h-full items-center border-t border-t-transparent bg-[#e4ebf3] px-4 text-xs",
                    isActive &&
                    "active border-t-2 border-t-primary bg-transparent",
                    activeIndex === index - 1 && "rounded-br-xl",
                    activeIndex === index + 1 && "rounded-bl-xl"
                  );
                }}
                end
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
        <div className="ms-auto flex items-center gap-x-5 text-xs">
          <LastUpdate />
          <ShareModal />
          <div className="flex items-center gap-x-1">
            <Edit size={12} className="text-[#30aab5]" />
            <p className="">ویرایش</p>
          </div>
        </div>
      </div>

      <div className="flex lg:hidden flex-col mb-2 w-full bg-[#E4EBF3]">
        <div className="flex items-center justify-between px-4 h-14 bg-[#E4EBF3]">
          <button onClick={() => setIsOpen(!isOpen)} className="p-2">
            {isOpen ? <X size={20} /> : <Menu size={20} />}
          </button>

          <div className="flex items-center gap-x-5 text-xs">
            <LastUpdate />
            <div>
              <ShareModal />
              <div className="flex items-center gap-x-1">
                <Edit size={12} className="text-[#30aab5]" />
                <p className="">ویرایش</p>
              </div>
            </div>
          </div>
        </div>

        {/* منوی قابل باز و بسته شدن */}
        {isOpen && (
          <ul className="flex flex-col absolute top-14 z-40 border-gray-300 bg-white shadow-md overflow-hidden">
            {profileEditNavItems.map((item, index) => (
              <li key={index}>
                <NavLink
                  to={item.href}
                  className={({ isActive }) => {
                    if (isActive) setActiveIndex(index);
                    return cn(
                      "navlink flex h-full items-center border-t border-t-transparent bg-[#e4ebf0f5] px-8 py-4",
                      isActive &&
                      "active border-t-2 border-t-primary bg-transparent",
                      activeIndex === index - 1 && "rounded-br-xl",
                      activeIndex === index + 1 && "rounded-bl-xl"
                    );
                  }}
                  end
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        )}
      </div>
    </>
  );
};
export default ProfileNavbar;
